import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "content-frame-wrapper" }
const _hoisted_3 = { class: "content-wrapper" }
const _hoisted_4 = {
  class: "page-title",
  "data-test": "page-title"
}
const _hoisted_5 = {
  class: "description",
  "data-test": "description"
}
const _hoisted_6 = {
  key: 0,
  class: "additional-note",
  "data-test": "additional-note"
}

import { onMounted, ref, watch } from "vue";
import { IonPage, IonContent } from "@ionic/vue";
import MobileHeader from "@/components/Common/MobileHeader/MobileHeader.vue";
import DesktopLocaleSelector from "@/components/Common/LocaleSelector/DesktopLocaleSelector.vue";
import Breadcrumbs from "@/components/Common/Breadcrumbs/Breadcrumbs.vue";
import ErrorModal from "@/components/Common/ErrorModal/ErrorModal.vue";
import AppModal from "@/components/Common/AppModal/AppModal.vue";
import { useErrorStore } from "@/store";
import { onBeforeRouteLeave } from "vue-router";
import { useI18n } from "vue-i18n";
interface BreadcrumbProp {
  type?: string;
  route?: string;
  label?: string;
}

interface Props {
  breadcrumbs: BreadcrumbProp[];
  mainContentId: string;
  formSaveRetryFunction?: () => void;
  skipOnRouteBeforeLeave?: boolean;
  formDeleteFunction?: () => void;
  dismissDeleteModal?: () => void;
  triggerDeleteModal?: boolean;
}

type userActionType = "confirmed" | "cancelled";
type userDeleteActionType = "delete" | "cancel";


export default /*@__PURE__*/_defineComponent({
  __name: 'ResumeBase',
  props: {
    breadcrumbs: {},
    mainContentId: {},
    formSaveRetryFunction: { type: Function },
    skipOnRouteBeforeLeave: { type: Boolean },
    formDeleteFunction: { type: Function },
    dismissDeleteModal: { type: Function },
    triggerDeleteModal: { type: Boolean }
  },
  setup(__props: any) {

const { t } = useI18n<{}>({
  useScope: "global",
});

const props = __props;

const breadcrumb = ref<BreadcrumbProp>();

const parentBreadcrumb = ref<BreadcrumbProp>();

const grandparentBreadcrumb = ref<BreadcrumbProp>();

const errorStore = useErrorStore();

const showReturnWithoutSaveModal = ref(false);
const showDeleteModal = ref(false);
const userAction = ref<userActionType>(null);
const userDeleteAction = ref<userDeleteActionType>(null);

watch(
  () => props.triggerDeleteModal,
  async (newVal) => {
    if (newVal === true) {
      openDeleteModal((result) => {
        if (result) {
          props.formDeleteFunction();
        } else {
          props.dismissDeleteModal();
        }
      });
    }
  }
);
onBeforeRouteLeave((to, from, next) => {
  // Skip triggering modal for e2e tests
  if (window.skipReturnWithoutSaveModal === true) {
    next();
    return;
  }
  if (!props.skipOnRouteBeforeLeave) {
    openReturnWithoutSaveModal((result) => {
      if (result) {
        next();
      } else {
        next(false);
      }
    });
  } else {
    next();
  }
});

onMounted(async () => {
  const parent = props.breadcrumbs.find(
    (breadcrumb) => breadcrumb.type === "parent"
  );

  if (parent) {
    parentBreadcrumb.value = {
      ...parent,
      type: "resume",
    };

    grandparentBreadcrumb.value = {
      label: t("resume.breadcrumbs.resume"),
      type: "resume",
    };
  } else {
    parentBreadcrumb.value = {
      label: t("resume.breadcrumbs.resume"),
      type: "resume",
    };
  }

  breadcrumb.value = props.breadcrumbs.find((breadcrumb) => !breadcrumb.type);
});

const dismissErrorModal = () => {
  errorStore.setGenericError(false); //Toggle off to avoid duplicate modals
  errorStore.setSaveFormError(false);
};

const openDeleteModal = (callback) => {
  showDeleteModal.value = true;
  const unwatch = watch(userDeleteAction, (newValue) => {
    if (newValue === "delete") {
      userDeleteAction.value = "";
      showDeleteModal.value = false;
      unwatch(); // Stop the watcher
      callback(true);
    } else if (userDeleteAction.value === "cancel") {
      userDeleteAction.value = "";
      showDeleteModal.value = false;
      unwatch(); // Stop the watcher
      callback(false);
    }
  });
};

const openReturnWithoutSaveModal = (callback) => {
  showReturnWithoutSaveModal.value = true;

  const unwatch = watch(userAction, (newValue) => {
    if (userAction.value) {
      if (newValue === "confirmed") {
        userAction.value = "";
        showReturnWithoutSaveModal.value = false;
        unwatch(); // Stop the watcher
        callback(true);
      } else if (newValue === "cancelled") {
        userAction.value = "";
        showReturnWithoutSaveModal.value = false;
        unwatch(); // Stop the watcher
        callback(false);
      }
    }
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(MobileHeader),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createVNode(DesktopLocaleSelector),
          _createElementVNode("div", {
            class: "page-wrapper",
            id: __props.mainContentId,
            tabindex: "-1"
          }, [
            _createVNode(Breadcrumbs, {
              tab: "tools",
              grandparentType: grandparentBreadcrumb.value?.type,
              grandparentTitle: grandparentBreadcrumb.value?.label,
              parentType: parentBreadcrumb.value?.type,
              parent: parentBreadcrumb.value?.route,
              parentTitle: parentBreadcrumb.value?.label,
              doc: breadcrumb.value?.label
            }, null, 8, ["grandparentType", "grandparentTitle", "parentType", "parent", "parentTitle", "doc"]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("h1", _hoisted_4, [
                    _renderSlot(_ctx.$slots, "title")
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _renderSlot(_ctx.$slots, "description")
                  ]),
                  (_ctx.$slots['additional-note'])
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _renderSlot(_ctx.$slots, "additional-note")
                      ]))
                    : _createCommentVNode("", true),
                  _renderSlot(_ctx.$slots, "main-content"),
                  _renderSlot(_ctx.$slots, "resume-helper")
                ])
              ])
            ])
          ], 8, _hoisted_1),
          (showReturnWithoutSaveModal.value)
            ? (_openBlock(), _createBlock(AppModal, {
                key: 0,
                isOpen: showReturnWithoutSaveModal.value,
                title: _ctx.$t('resume.returnWithoutSaveModal.title'),
                body: _ctx.$t('resume.returnWithoutSaveModal.body'),
                primaryButton: {
          label: _unref(t)('resume.returnWithoutSaveModal.primaryButtonText'),
        },
                secondaryButton: {
          label: _unref(t)('resume.returnWithoutSaveModal.secondaryButtonText'),
        },
                onOnPrimaryButtonClick: _cache[0] || (_cache[0] = ($event: any) => (userAction.value = 'confirmed')),
                onOnSecondaryButtonClick: _cache[1] || (_cache[1] = ($event: any) => (userAction.value = 'cancelled')),
                "data-test": "return-without-save-modal"
              }, null, 8, ["isOpen", "title", "body", "primaryButton", "secondaryButton"]))
            : _createCommentVNode("", true),
          (showDeleteModal.value)
            ? (_openBlock(), _createBlock(AppModal, {
                key: 1,
                isOpen: showDeleteModal.value,
                title: _ctx.$t('resume.deleteFormModal.title'),
                primaryButton: {
          label: _unref(t)('resume.deleteFormModal.primaryButtonText'),
        },
                secondaryButton: {
          label: _unref(t)('resume.deleteFormModal.secondaryButtonText'),
        },
                onOnPrimaryButtonClick: _cache[2] || (_cache[2] = ($event: any) => (userDeleteAction.value = 'delete')),
                onOnSecondaryButtonClick: _cache[3] || (_cache[3] = ($event: any) => (userDeleteAction.value = 'cancel')),
                "data-test": "delete-form-modal"
              }, null, 8, ["isOpen", "title", "primaryButton", "secondaryButton"]))
            : _createCommentVNode("", true),
          _withDirectives(_createVNode(ErrorModal, {
            hasErrored: _unref(errorStore).hasSaveFormError,
            "data-test": "error-modal-save",
            class: "error-modal",
            title: _unref(t)('resume.saveFormErrorModal.title'),
            body: _unref(t)('resume.saveFormErrorModal.body'),
            primaryButton: {
          label: _unref(t)('resume.saveFormErrorModal.primaryButtonText'),
        },
            secondaryButton: {
          label: _unref(t)('resume.saveFormErrorModal.secondaryButtonText'),
        },
            onOnPrimaryButtonClick: __props.formSaveRetryFunction,
            onOnSecondaryButtonClick: dismissErrorModal,
            onOnDismiss: dismissErrorModal
          }, null, 8, ["hasErrored", "title", "body", "primaryButton", "secondaryButton", "onOnPrimaryButtonClick"]), [
            [_vShow, _unref(errorStore).hasSaveFormError]
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})